module.exports = __webpack_public_path__ + "images/yellow_small.png";